import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { StateChart } from '../app-model/state-chart/state-chart.model';
import { ApiProxyService } from '../modules/shared/services/api-proxy.service';
import { MessageService } from '../modules/shared/services/message-service.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class StateChartService {

  constructor(private apiProxy: ApiProxyService,
    private messageService: MessageService,
    private configService: ConfigService) { }

  getAll(specificationVersionId: number): Observable<StateChart[]> {
    return this.apiProxy.get<StateChart[]>(`${this.configService.apiUrl}charts?specificationVersionId=${specificationVersionId}`)
      .pipe(map(items => items));
  }
}
